import { Spin, Tag } from 'antd';
import IconNoData from './../../../../assets/Images/icons/icon-no-data';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function RelatedActivities({ activites }) {
    const { t } = useTranslation();
    return (
        <div>
            <Spin spinning={!activites}>
                {activites && activites?.length > 0 ? (
                    <div className="space-y-2">
                        {activites?.map((val) => (
                            <>
                                <div className="bg-[#F4F6FC] w-full space-y-1 py-3 px-[10px] rounded-md">
                                    <div className="space-x-3 flex items-center">
                                        <div className="font-semibold text-sm">
                                            {val?.activityName}
                                        </div>
                                    </div>
                                    <Tag className="font-medium text-[#1890FF] bg-[white] rounded-[10px] border-[1px] border-[#1890FF] border-solid px-2 text-sm">
                                        {val?.department}
                                    </Tag>
                                </div>
                            </>
                        ))}
                    </div>
                ) : (
                    <>
                        <div className="text-center text-sm space-y-2 my-32">
                            <IconNoData />
                            <p className="text-[#65707A] text-[14px]">
                                {t('common.noData')}
                            </p>
                        </div>
                    </>
                )}
            </Spin>
        </div>
    );
}
